<template>
  <div class="dimmed">
    <div class="guide--wrap" @click.stop>
      <p class="title">{{ $t('common.matchResult') }}</p>

      <div class="contents--wrap">
        <div class="entered__info--wrap">
          <p v-if="requireDomain">
            <span class="entered-match-type">{{ $t('common.domain') }}</span>
            <span class="entered-url">{{ enteredValueDomain }}</span>
            <span class="entered-match-type domain">{{ enteredMatchType === 'end' ? 'Ends Text' : 'Contains Text' }}</span>
            <span class="entered-url">{{ enteredCriterion }}</span>
          </p>
          <p v-else>
            <span class="entered-match-type">{{ $t('common.url') }}</span>
            <span class="entered-url">{{ enteredValue }}</span>
          </p>
        </div>

        <div class="content--wrap">
          <div class="url-example">
            <div class="table-header">
              <table>
                <colgroup>
                  <col width="167">
                  <col width="*">
                </colgroup>
                <thead>
                <tr>
                  <th>{{ $t('common.table.header.match') }}</th>
                  <th>{{ $t('common.table.header.url') }}</th>
                </tr>
                </thead>
              </table>
            </div>
            <div class="table-body">
              <table>
                <colgroup>
                  <col width="167">
                  <col width="*">
                </colgroup>
                <tbody v-if="enteredMatchType === 'exact'">
                <tr class="matched">
                  <td>Exact match</td>
                  <td><span>{{ enteredURL }}</span></td>
                </tr>
                <tr class="disableMatch">
                  <td><span>Protocol</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | toggleSecurity }}</span></td>
                </tr>
                <tr class="disableMatch" v-if="hasSubDomain">
                  <td><span>Domain</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | noSubDomain }}</span></td>
                </tr>
                <tr class="disableMatch" v-else>
                  <td><span>Domain</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | noSubDomain | subDomain }}</span></td>
                </tr>
                <tr class="disableMatch" v-if="hasPath">
                  <td><span>Path</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | noPath | path }}</span></td>
                </tr>
                <tr class="disableMatch" v-else>
                  <td><span>Path</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | path }}</span></td>
                </tr>
                <tr class="disableMatch" v-if="hasQuery">
                  <td><span>Parameter</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | noQuery }}</span></td>
                </tr>
                <tr class="disableMatch" v-else>
                  <td><span>Parameter</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | addQuery }}</span></td>
                </tr>
                <tr class="disableMatch" v-if="hasHash">
                  <td><span>Fragment</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | noHash }}</span></td>
                </tr>
                <tr class="disableMatch" v-else>
                  <td><span>Fragment</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | hash }}</span></td>
                </tr>
                </tbody>

                <tbody v-else-if="enteredMatchType === 'simple'" >
                <tr class="matched">
                  <td>Simple match</td>
                  <td><span>{{ enteredURL }}</span></td>
                </tr>
                <tr class="matched">
                  <td>Simple match</td>
                  <td><span>{{ enteredURL | toggleSecurity }}</span></td>
                </tr>
                <tr class="matched">
                  <td>Simple match</td>
                  <td><span>{{ enteredURL | toggleWww }}</span></td>
                </tr>
                <tr class="matched">
                  <td>Simple match</td>
                  <td><span>{{ enteredURL | addQuery }}</span></td>
                </tr>
                <tr class="disableMatch" v-if="!hasSubDomain">
                  <td><span>Domain</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | subDomain }}</span></td>
                </tr>
                <tr class="disableMatch" v-else-if="hasWwwSubDomain">
                  <td><span>Domain</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | noSubDomain | subDomain }}</span></td>
                </tr>
                <tr class="disableMatch" v-else>
                  <td><span>Domain</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | noSubDomain }}</span></td>
                </tr>
                <tr class="disableMatch" v-if="hasPath">
                  <td><span>Path</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | noPath }}</span></td>
                </tr>
                <tr class="disableMatch" v-else>
                  <td><span>Path</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | path }}</span></td>
                </tr>
                </tbody>

                <tbody v-else-if="enteredMatchType === 'start'">
                <tr class="matched">
                  <td>Starts match</td>
                  <td><span>{{ enteredURL }}</span></td>
                </tr>
                <tr class="matched" v-if="!hasQuery && !hasHash">
                  <td>Starts match</td>
                  <td><span>{{ enteredURL | path }}</span></td>
                </tr>
                <tr class="matched" v-if="!hasHash">
                  <td>Starts match</td>
                  <td><span>{{ enteredURL | addQuery }}</span></td>
                </tr>
                <tr class="matched">
                  <td>Starts match</td>
                  <td><span>{{ enteredURL | hash }}</span></td>
                </tr>
                <tr class="disableMatch">
                  <td><span>Protocol</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | toggleSecurity }}</span></td>
                </tr>
                <tr class="disableMatch">
                  <td><span>Domain</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | toggleWww }}</span></td>
                </tr>
                <tr class="disableMatch" v-if="!hasSubDomain">
                  <td><span>Domain</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | subDomain }}</span></td>
                </tr>
                <tr class="disableMatch" v-else-if="!hasWwwSubDomain">
                  <td><span>Domain</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | noSubDomain }}</span></td>
                </tr>
                </tbody>

                <tbody v-else-if="enteredMatchType === 'end'">
                <tr class="matched">
                  <td>Ends match</td>
                  <td><span>{{ enteredValueDomainCriterion }}</span></td>
                </tr>
                <tr class="matched">
                  <td>Ends match</td>
                  <td><span>{{ enteredValueDomainCriterion | toggleSecurity }}</span></td>
                </tr>
                <tr class="matched">
                  <td>Ends match</td>
                  <td><span>{{ enteredValueDomainCriterion | toggleWww }}</span></td>
                </tr>
                <tr class="matched" v-if="hasHashCriterion">
                  <td>Ends match</td>
                  <td><span>{{ enteredValueDomainCriterion | addQuery }}</span></td>
                </tr>
                <tr class="matched" v-else-if="hasQueryCriterion">
                  <td>Ends match</td>
                  <td><span>{{ enteredValueDomainCriterion | path }}</span></td>
                </tr>
                <tr class="matched" v-else>
                  <td>Ends match</td>
                  <td><span>{{ enteredURL | path }}{{ enteredCriterion }}</span></td>
                </tr>
                <tr class="disableMatch" v-if="!hasSubDomain">
                  <td><span>Domain</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredValueDomainCriterion | subDomain }}</span></td>
                </tr>
                <tr class="disableMatch" v-else-if="!hasWwwSubDomain">
                  <td><span>Domain</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredValueDomainCriterion | noSubDomain }}</span></td>
                </tr>
                <tr class="disableMatch">
                  <td><span>Ends Text</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredValueDomainCriterion | hash }}</span></td>
                </tr>
                </tbody>

                <tbody v-else-if="enteredMatchType === 'contains'">
                <tr class="matched">
                  <td>Contains match</td>
                  <td><span>{{ enteredValueDomainCriterion }}</span></td>
                </tr>
                <tr class="matched">
                  <td>Contains match</td>
                  <td><span>{{ enteredValueDomainCriterion | toggleSecurity }}</span></td>
                </tr>
                <tr class="matched">
                  <td>Contains match</td>
                  <td><span>{{ enteredValueDomainCriterion | addQuery }}</span></td>
                </tr>
                <tr class="matched">
                  <td>Contains match</td>
                  <td><span>{{ enteredValueDomainCriterion | hash }}</span></td>
                </tr>
                <tr class="matched">
                  <td>Contains match</td>
                  <td><span>{{ enteredValueDomainCriterion | toggleWww }}</span></td>
                </tr>
                <tr class="disableMatch" v-if="!hasSubDomain">
                  <td><span>Domain</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredValueDomainCriterion | subDomain }}</span></td>
                </tr>
                <tr class="disableMatch" v-else-if="!hasWwwSubDomain">
                  <td><span>Domain</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredValueDomainCriterion | noSubDomain }}</span></td>
                </tr>
                <tr class="disableMatch" v-else>
                  <td><span>Domain</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredValueDomainCriterion | noSubDomain | subDomain }}</span></td>
                </tr>
                <tr class="disableMatch">
                  <td><span>Contains Text</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | path(enteredCriterion.indexOf('path') !== -1 ? 'dir' : 'path') }}</span></td>
                </tr>
                <tr class="disableMatch">
                  <td><span>Contains Text</span> {{ $t('common.invalidMatch') }}</td>
                  <td><span>{{ enteredURL | addQuery(enteredCriterion.indexOf('x=1') !== -1 ? 'y=2' : 'x=1') }}</span></td>
                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
      <div class="button--wrap">
        <button class="btn__close" @click="onCloseLayer">{{ $t('common.confirm') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getOriginFromUrl } from '@/libs/apply-helper'
import { has2Tld } from '@/libs/utils'

export default {
  filters: {
    toggleSecurity: (value) => {
      if (value.indexOf('https') === 0) {
        return value.replace('https', 'http')
      } else {
        return value.replace('http', 'https')
      }
    },
    toggleWww: (value) => {
      let parser = document.createElement('a')
      parser.href = value
      const fragment = parser.href.replace(parser.protocol + '//' + parser.hostname, '')
      let list = parser.hostname.split('.')
      if (list[0] === 'www') {
        list.shift()
      } else {
        list.unshift('www')
      }
      let returnURL = parser.protocol + '//' + list.join('.') + fragment
      return returnURL
    },
    noSubDomain: (value) => {
      let parser = document.createElement('a')
      parser.href = value
      let list = value.split('.')
      if (list.length >= (has2Tld(value) ? 4 : 3)) {
        list.shift()
        let returnURL = parser.protocol + '//' + list.join('.')
        return returnURL
      } else {
        return value
      }
    },
    subDomain: (value, sub = 'sub') => {
      let parser = document.createElement('a')
      parser.href = value
      let list = parser.href.replace(parser.protocol + '//', '').split('.')
      list.unshift(sub)
      let returnURL = parser.protocol + '//' + list.join('.')
      return returnURL
    },
    hasQueryFilter: (value) => {
      let parser = document.createElement('a')
      parser.href = value
      if (parser.search) {
        return true
      } else {
        return false
      }
    },
    noQuery: (value) => {
      let parser = document.createElement('a')
      parser.href = value
      if (parser.search) {
        parser.search = ''
        return parser.href
      } else {
        return value
      }
    },
    addQuery: (value, query = 'x=1') => {
      let parser = document.createElement('a')
      parser.href = value
      if (parser.search) {
        parser.search += `&${query}`
      } else {
        parser.search = query
      }
      return parser.href
    },
    noHash: (value) => {
      let parser = document.createElement('a')
      parser.href = value
      if (parser.hash) {
        parser.hash = ''
        return parser.href
      } else {
        return value
      }
    },
    hash: (value, hash = 'hash') => {
      let parser = document.createElement('a')
      parser.href = value
      if (parser.hash) {
        return value
      } else {
        parser.hash = hash
        return parser.href
      }
    },
    noPath: (value) => {
      let parser = document.createElement('a')
      parser.href = value
      parser.pathname = ''
      return parser.href
    },
    path: (value, pathname = 'path') => {
      let parser = document.createElement('a')
      parser.href = value
      if (parser.pathname === '/') {
        parser.pathname = pathname
        return parser.href
      } else {
        if (parser.pathname[parser.pathname.length - 1] === '/') {
          parser.pathname += pathname
        } else {
          parser.pathname += `/${pathname}`
        }
        let obj = {}
        let href = parser.href
        let startIndex = href.lastIndexOf('/')
        let endIndex = href.length
        obj.domain = href.substring(0, startIndex)
        obj.pathname = href.substring(startIndex, endIndex)
        href = obj.domain + obj.pathname
        return href
      }
    }
  },
  props: [
    'requireDomain',
    'enteredMatchType',
    'enteredURL',
    'enteredCriterion',
    'enteredSiteCode'
  ],
  data () {
    return {
      way: ''
    }
  },
  computed: {
    hasPath () {
      let parser = document.createElement('a')
      parser.href = this.enteredURL
      return parser.pathname && parser.pathname !== '/'
    },
    hasQuery () {
      return this.enteredURL.indexOf('?') > -1
    },
    hasQueryCriterion () {
      return this.enteredCriterion.indexOf('?') > -1
    },
    hasHash () {
      return this.enteredURL.indexOf('#') > -1
    },
    hasHashCriterion () {
      return this.enteredCriterion.indexOf('#') > -1
    },
    hasSubDomain () {
      return this.enteredURL.split('.').length > (has2Tld(this.enteredURL) ? 3 : 2)
    },
    hasWwwSubDomain () {
      return this.firstSubDomain === 'www'
    },
    firstSubDomain () {
      let parser = document.createElement('a')
      parser.href = this.enteredURL
      return parser.hostname.split('.')[0]
    },
    enteredValue () {
      let urlValue = document.createElement('a')
      urlValue.href = this.enteredURL
      return urlValue.href
    },
    enteredValueDomain () {
      let urlValue = document.createElement('a')
      urlValue.href = this.enteredURL
      return getOriginFromUrl(urlValue.href)
    },
    enteredValueDomainCriterion () {
      let urlValue = document.createElement('a')
      urlValue.href = this.enteredURL
      let siteCodePath = this.$route.name === 'page-add' ? '/' + this.enteredSiteCode : null
      let returnValue = getOriginFromUrl(urlValue.href) + (siteCodePath || '')
      if (this.enteredCriterion[0] === '/') {
        returnValue += this.enteredCriterion
      } else {
        returnValue += `/${this.enteredCriterion}`
      }
      return returnValue
    }
  },
  methods: {
    onCloseLayer () {
      this.$emit('closeLayer', false)
    }
  }
}
</script>

<style lang="scss" scoped>
  .guide--wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 640px;
    border-radius: 14px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    box-sizing: border-box;

    & > .title {
      font-size: 15px;
      font-weight: bold;
      line-height: 1;
      color: #2f2f2f;
      margin-top: 30px;
      padding-left: 30px;
      padding-right: 30px;
      height: 28px;
    }

    .contents--wrap {
      padding-left: 30px;
      padding-right: 30px;
      padding-bottom: 13px;
      overflow: auto;
      min-height: 307px;
      max-height: calc(100vh - 243px);

      .entered__info--wrap {
        margin-top: 30px;
        position: relative;

      .entered-match-type {
        padding-left: 5px;
        padding-right: 5px;
        box-sizing: border-box;
        min-width: 40px;
        height: 16px;
        line-height: 16px;
        border-radius: 4px;
        background-color: #8d8d8d;
        display: inline-block;
        font-size: 12px;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
        margin-right: 8px;
        float: left;

        &.domain {
          margin-left: 10px;
        }
      }
      .entered-url {
        font-size: 15px;
        color: #444444;
        width: calc(100% - 55px);
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 16px;
      }
    }

      .content--wrap {
        margin-top: 20px;

      .url-example {
        .table-header {
          height: 40.5px;
        }
        .table-body {
          height: 240.5px;
          overflow: auto;
        }
        table {
          width: calc(100% - 15px);
          tr {
            height: 40px;
            th, td {
              padding-left: 16px;
            }

            td {
              &:nth-child(1) {
                max-width: 167px;
              }
              &:nth-child(2) {
                max-width: 413px;

                & span {
                  display: inline-block;
                  width: 100%;
                  word-break: break-all;
                  margin: 13px 0;
                }
              }
            }
          }
          thead {
            tr {
              border-bottom: 1px solid #bbb;
              th {
                text-align: left;
                font-size: 12px;
                line-height: 1;
                color: #444444;
              }
            }
          }
          tbody {
            tr {
              border-bottom: 1px dashed #d7d7d7;

                &.matched {
                  td {
                    color: #3eaa08;
                    font-weight: bold;
                  }
                }

                &.disableMatch {
                }

                td {
                  font-size: 13px;
                  color: #999999;
                  word-break: break-all;
                  padding-top: 10px;
                  padding-bottom: 10px;
                }
              }
            }
          }
        }
      }
    }

    .button--wrap {
      height: 63px;
      padding-top: 22px;
      margin-top: 0 !important;

      .btn__close {
        display: block;
        min-width: 86px;
        height: 38px;
        border-radius: 20px;
        border: solid 1px #bbbbbb;
        background-color: #ffffff;
        font-size: 14px;
        font-weight: bold;
        line-height: 1;
        color: #444444;
        margin: 0 auto;
      }
    }
  }
</style>
